<template>
  <div class="bottonTab">
    <div class="hint" v-if="isShow"><span style="margin-right: 5px;"> 当前交易日: {{ currentday }} </span><span style="margin-right: 5px;"> 交易日数: {{ daydiff }} </span>  本网页报价仅供客户参考，不作为下单依据，实际可成交价格以交易台报价为准。详情请联系0571-8658 5071</div>
    <Row class="bott">
      <router-link to="/" active-class="activeColor" exact>
        <Col span="6"><Icon type="md-home" size="26"/><p>报价</p></Col>
      </router-link>
      <!-- 2021-04-27 展示先注释掉除报价和自选外的其余界面, 询价界面应在"更多"标签内, 暂时先放开 -->
      <router-link to="/ConsultPrice" active-class="activeColor" exact>
        <Col span="6"><Icon type="logo-usd" size="26"/><p>询价</p></Col>
      </router-link> 
      <router-link to="/optional" active-class="activeColor" exact>
        <Col span="6"><Icon type="ios-hand" size="26"/><p>自选</p></Col>
      </router-link>
      <!-- 2021-04-27 暂时先注释掉除报价和自选外的其余界面 -->
    <!--  <router-link to="/deal" active-class="activeColor" exact>
        <Col span="6"><Icon type="md-cart" size="26"/><p>交易</p></Col>
      </router-link> 
       <router-link to="/more" active-class="activeColor" exact>
        <Col span="6"><Icon type="ios-more" size="26"/><p>更多</p></Col>
      </router-link>  -->
    </Row>
  </div>
</template>

<script>
export default {
  name: 'BottonTab',
  data () {
    return {
      shows: 1
    }
  },
  methods: {},

  props: ['isShow', 'currentday', 'daydiff']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bottonTab {
  height: 20px;
}
.bott{
  padding-top: 4px;
  width: 100%;
  max-width: 750px;
  height: 2.5rem;
  text-align: center;
  background-color: #fff;
  border-top: 1px solid #ccc;
  position: fixed;
  bottom: 0;
  z-index: 3;
  font-size: 0.5rem;
}
.bott a{
  color: #999
}
.bott .activeColor{
  color: rgb(0, 122, 255);
}
.hint {
  width: 100%;
  max-width: 750px;
  background: #f00;
  color: #fff;
  font-size: 12px;
  padding: 0 10px;
  text-align: center;
  position: fixed;
  bottom: 2.5rem;
}
</style>
